export default __webpack_public_path__ + "static/Rectangle4387-e86161d54448d7801b4c0e1a8ad0bf3b.png";